import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import ElectronicVaccinationCreateReactionForm from './ElectronicVaccinationCreateReactionForm';
import useTranslation from '../../../../../Hooks/useTranslation';
import { NCZIExtension } from '../../../Interfaces/ncziTypes';
import { Size } from '../../../../../Enums/Size.enum';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	patientIdentifier: string;
	vaccinationId: NCZIExtension;
}

const ElectronicVaccinationCreateReactionModal: React.FC<Props> = props => {
	const { opened, onClose, patientIdentifier, vaccinationId } = props;

	const { t } = useTranslation();
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(false)}
			fullScreen={false}
			size={Size.SM}
			wrapChat={isCase}>
			<Modal.Header title='nczi.vaccination.reaction.create.title' firstUpper />
			<Modal.Content>
				<ElectronicVaccinationCreateReactionForm
					onClose={onClose}
					patientIdentifier={patientIdentifier}
					vaccinationId={vaccinationId}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicVaccinationCreateReactionModal;
